// extracted by mini-css-extract-plugin
export default {"ColSty":"CurrentThirtyDaysChargingStation_ColSty__PQQpg"};